import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'
import { attemptSearchSongs } from './songsSlice'

interface Statistic {
  songs: number
  users: number
  playlists: number
  notValidatedUsers: number
  ordersWithoutPlaylist: number
}

interface State extends Statistic {
}

export const initialState: Partial<State> = {
}

export const attemptGetStatistics = createAsyncThunk<any, void>(
  'statistics/get',
  async (payload) => {
    const response = await $api.get('statistic/admin')
    return response.data
  },
)

export const attemptGetListeningStatistics = createAsyncThunk<any, { userId: string; year: number }>(
  'statistics/listen/get',
  async (payload) => {
    const response = await $api.get(`statistic/admin/listen/${payload.userId}/${payload.year}`)
    return response.data
  },
)


export const statisticsReducer = createSlice({
  name: 'statistics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(attemptGetStatistics.fulfilled, (state, { payload }) => {
      state.songs = payload.songs
      state.users = payload.users
      state.playlists = payload.playlists
      state.notValidatedUsers = payload.notValidatedUsers
      state.ordersWithoutPlaylist = payload.ordersWithoutPlaylist
    })
    builder.addCase(attemptSearchSongs.fulfilled, (state, { payload }) => {
      state.songs = payload.total
    })
  },
})

export const {} = statisticsReducer.actions
export default statisticsReducer.reducer
